import '../assets/css/about.css';
import '../assets/css/slideText.css';
import introImg from '../assets/images/introImg.jpg';
import professionalbackground from '../assets/images/professionalbackground.png';
import technicalExpertise from '../assets/images/technicalExpertise.jpg';
import approach from '../assets/images/approach.jpg';
import cooking from '../assets/images/cooking.jpg';
import hiking from '../assets/images/hiking.jpg';

import React, { useEffect, useRef, useState } from 'react';

const About = () => {

    const refArr = useRef([]);
    const aboutContainerRef = useRef(null);
    const introParallaxRef = useRef(null);
    const [isIphone, setIsIphone] = useState(false); // State to detect iPhone

    const introStyle = {
        backgroundImage: `url(${introImg})`
    }
    const professionalbackgroundStyle = {
        backgroundImage: `url(${professionalbackground})`,

    }
    const technicalExpertiseStyle = {
        backgroundImage: `url(${technicalExpertise})`
    }
    const approachStyle = {
        backgroundImage: `url(${approach})`
    }
    const cookingStyle = {
        backgroundImage: `url(${cooking})`
    }
    const hikingStyle = {
        backgroundImage: `url(${hiking})`
    }

    const handleScroll4parallax = () => {
        const scrollPosition = window.scrollY;
        const parallaxElement = introParallaxRef.current;

        if (parallaxElement) {
            const windowHeight = window.innerHeight;
            const elementTop = parallaxElement.getBoundingClientRect().top;

            const offset = (windowHeight - elementTop) * 0.3; // Adjust speed factor
            parallaxElement.style.transform = `translateY(${offset}px)`;
        }
    };

    const handleScroll = () => {

        // handleScroll4parallax();

        refArr.current.forEach((element) => {
            const position = element.getBoundingClientRect().top;
            const windowHeight = window.innerHeight;
            const e_height = element.offsetHeight;

            if (position < (windowHeight - e_height) && position > (-e_height)) {
                element.classList.add('active');
            } else {
                element.classList.remove('active');
            }
        });

    };


    // Detect if the user is on an iPhone
    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/iPhone/i.test(userAgent)) {
            setIsIphone(true);
        }
    }, []);

    useEffect(() => {

        // Add scroll event listener
        aboutContainerRef.current.addEventListener('scroll', handleScroll);

        // Cleanup event listener on component unmount
        return () => {
            if (aboutContainerRef != null) {
                if (aboutContainerRef.current != null) {
                    aboutContainerRef.current.removeEventListener('scroll', handleScroll);
                }
            }
        };

    }, []);


    return (
        <>
            <h1 className="heading title">ABOUT ME</h1>
            <section className="about_container" ref={aboutContainerRef}>

                {/* <h2 className="welcome">Welcome!</h2> */}
                <div className="about-me-container-card about-card">
                    <p className="intro_p">
                        I'm <b>Md Mohib Khan</b>, a dedicated web developer with over 4+ years of experience
                        in crafting responsive and engaging websites and web applications.
                        <br />My journey in web development has been driven by a passion for
                        creating high-quality digital experiences that meet user needs and business goals.
                    </p>
                </div>

                {!isIphone &&
                    <div style={introStyle} class="parallax"></div>
                }

                {/* <div className="parallax">
                <div
                    className="parallax-inner"
                    ref={introParallaxRef}
                    style={introStyle}
                ></div>
            </div> */}



                {/* <hr /> */}
                <div className="about-me-container-card professional-card">
                    <h2 className="professional_h slide-in-left" ref={(el) => (refArr.current[0] = el)}>Professional Background</h2>

                    <p className="professional_p1 slide-in-left" ref={(el) => (refArr.current[1] = el)}>I hold a <b>Bachelor of Science in Information Technology (B.Sc.IT.) </b> from <b>Ranchi University</b>,
                    </p>
                    <p className="professional_p1 remove-gap-from-p slide-in-left" ref={(el) => (refArr.current[2] = el)}> a comprehensive 3 years program that laid the foundation for my technical expertise.
                    </p>

                    <p className="professional_p1 slide-in-left" ref={(el) => (refArr.current[3] = el)}>
                        Following this, I completed a <b>Master in Computer Application (MCA) </b> from <b>Aligarh Muslim University (AMU) </b>,
                    </p>
                    <p className="professional_p1 remove-gap-from-p slide-in-left" ref={(el) => (refArr.current[4] = el)}>
                        a rigorous 3 years course that deepened my knowledge and skills in computer science.
                    </p>
                </div>

                {!isIphone &&
                    <div style={professionalbackgroundStyle} class="parallax"></div>
                }

                <div className="about-me-container-card professional2">
                    <p className="professional_p2 slide-in-left" ref={(el) => (refArr.current[5] = el)} >After my academic pursuits,
                        I joined <b>ZMQ Development</b> as an intern and have since advanced to the role of a <b>Full Stack Web Developer</b>.

                    </p>
                    <p className="professional_p2 remove-gap-from-p2 slide-in-left" ref={(el) => (refArr.current[6] = el)} >Over the past 4+ years at ZMQ Development,
                        I have worked on numerous projects,
                    </p>
                    <p className="professional_p2 remove-gap-from-p2 slide-in-left" ref={(el) => (refArr.current[7] = el)} >gaining extensive experience in both front-end and back-end development.
                        Notable projects include:
                    </p>

                    <p className="professional_p3 slide-in-left" ref={(el) => (refArr.current[8] = el)}>
                        <b>* PMNE:</b> A project monitoring and evaluation platform.
                    </p>

                    <p className="professional_p3 remove-gap-from-p slide-in-left" ref={(el) => (refArr.current[9] = el)}>
                        <br /><b>* Universal TB Platform:</b> A system for monitoring TB patients' adherence, utilizing methods like VOT, Pillbox, SMS, and DOTS.
                    </p>
                    <p className="professional_p3 remove-gap-from-p slide-in-left" ref={(el) => (refArr.current[10] = el)}>
                        <br /><b>* Data Visualization Platform:</b> A tool for visualizing geographic data on maps.
                    </p>
                </div>

                {!isIphone &&
                    <div style={technicalExpertiseStyle} class="parallax"></div>
                }

                {/* <hr /> */}
                <div className="about-me-container-card">
                    <h2 className="expertise_h slide-in-left" ref={(el) => (refArr.current[11] = el)} >Technical Expertise</h2>
                    <p className="expertise_p slide-in-left" ref={(el) => (refArr.current[12] = el)} >
                        I am proficient in a range of technologies including
                    </p>
                    <p className="expertise_p remove-gap-from-p slide-in-left" ref={(el) => (refArr.current[13] = el)} >
                        JavaScript, React JS, PHP, Codeigniter, Laravel, Node JS, Express JS, Java, MySQL, and PostgreSQL.
                    </p>

                    <p className="expertise_p slide-in-left" ref={(el) => (refArr.current[14] = el)} >
                        My robust understanding of <b>front-end</b> and <b>back-end</b> development allows me to manage database systems, configure servers, and integrate APIs seamlessly.
                    </p>


                    <p className="expertise_p slide-in-left" ref={(el) => (refArr.current[15] = el)} >
                        My approach to web development is centered on delivering high-quality work within deadlines, ensuring both functionality and aesthetic appeal.
                    </p>
                </div>
                {!isIphone &&
                    <div style={approachStyle} class="parallax"></div>
                }

                {/* <hr /> */}
                <div className="about-me-container-card">
                    <h2 className="approach_h slide-in-left" ref={(el) => (refArr.current[16] = el)}>My Approach</h2>
                    <p className="approach_p slide-in-left" ref={(el) => (refArr.current[17] = el)}>
                        I am committed to staying up-to-date with the latest trends and technologies in web development.
                    </p>
                    <p className="approach_p slide-in-left" ref={(el) => (refArr.current[18] = el)}>
                        This commitment is reflected in my continuous learning and application of new skills and techniques to enhance user experiences and improve website performance.
                    </p>
                    <p className="approach_p slide-in-left" ref={(el) => (refArr.current[19] = el)}>
                        Whether it's a small business website or a complex web application,
                    </p>
                    <p className="approach_p remove-gap-from-p slide-in-left" ref={(el) => (refArr.current[20] = el)}>
                        I strive to deliver solutions that are both functional and aesthetically pleasing.
                    </p>
                </div>

                {!isIphone &&
                    <div style={hikingStyle} class="parallax"></div>

                }
                {/* {!isIphone &&
                    <div style={cookingStyle} class="parallax cooking-image"></div>
                } */}

                {/* <hr /> */}
                <div className="about-me-container-card beyond-coding-card">
                    <h2 className="beyond_h slide-in-left" ref={(el) => (refArr.current[21] = el)}>Beyond Coding</h2>
                    <p className="beyond_p slide-in-left" ref={(el) => (refArr.current[22] = el)}>
                        Outside of my professional work, I enjoy hiking and cooking.
                    </p>

                    <p className="beyond_p slide-in-left" ref={(el) => (refArr.current[23] = el)}>
                        Hiking allows me to clear my mind, reduce stress, and find fresh inspiration in nature,
                    </p>

                    <p className="beyond_p slide-in-left" ref={(el) => (refArr.current[24] = el)}>
                        while cooking helps me experiment with new recipes, fostering creativity and precision.
                    </p>

                    <p className="beyond_p slide-in-left" ref={(el) => (refArr.current[25] = el)}>
                        Additionally, I am involved in teaching coding to underprivileged students,
                    </p>
                    <p className="beyond_p remove-gap-from-p slide-in-left" ref={(el) => (refArr.current[26] = el)}>
                        which allows me to give back to the community and inspire the next generation of tech enthusiasts.
                    </p>
                </div>

                {!isIphone &&
                    <div style={cookingStyle} class="parallax cooking-image"></div>
                }

                {/* <hr /> */}

                <div className="about-me-container-card lets-connect-card">

                    <h2 className="connect_h slide-in-left" ref={(el) => (refArr.current[27] = el)}>Let's Connect</h2>

                    <p className="connect_p slide-in-left" ref={(el) => (refArr.current[28] = el)}>
                        I’m always excited to connect with new people and explore potential collaborations.
                        <br />Feel free to reach out to me through
                    </p>

                </div>

                <div className="about-me-container-card connect-card">
                    <section class="contact-section slide-in-left" ref={(el) => (refArr.current[29] = el)}>
                        <div class="container">
                            <div class="contact-details">
                                <div class="contact-item">
                                    <h3>Email</h3>
                                    <p><a href="mailto:indianmohibkhan@gmail.com">indianmohibkhan@gmail.com</a></p>
                                </div>
                                <div class="contact-item">
                                    <h3>Phone</h3>
                                    <p><a href="tel:+917091825476">+91 7091825476</a></p>
                                </div>
                                <div class="contact-item">
                                    <h3>LinkedIn</h3>
                                    <p><a href="https://www.linkedin.com/in/MdMohibKhan/" target="_blank">https://www.linkedin.com/in/MdMohibKhan</a></p>
                                </div>
                                <div class="contact-item">
                                    <h3>Location</h3>
                                    <p>New Delhi, India</p>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <div className="about-me-container-card connect-last-card">
                    <p className="connect_p connect_p_end slide-in-left" ref={(el) => (refArr.current[30] = el)}>
                        I look forward to hearing from you!
                    </p>
                </div>

                {/* <div className="about-me-container-card">
                <h2>Title</h2>
                <p>

                </p>
            </div> */}

                <br />
                <br />

            </section>
        </>
    );
}

export default About;